import { Injectable } from '@angular/core';
import { MenuItem } from "primeng/api";
import { BehaviorSubject } from "rxjs";

@Injectable({ providedIn: 'root' })
export class BreadCrumbService {
  constructor() { }

  protected items: BehaviorSubject<MenuItem[]> = new BehaviorSubject<MenuItem[]>([]);

  public setMenuItems(items: MenuItem[]) {
    this.items.next(items);
  }

  public getMenuItems() {
    return this.items;
  }
}
